import {
  Box,
  SxProps,
  Typography,
  useTheme,
  CardMedia,
  IconButton,
  CardContent,
  Card,
  IconButtonProps,
} from "@mui/material"
import { IServiceConfig } from "providers/venue/types"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"
import { useMemo } from "react"
import { getIcon } from "utils/icon"
import { ArrowNextIcon } from "components/icons"

interface IServiceCardProps {
  sx?: SxProps
  data: IServiceConfig
  iconButtonProps?: IconButtonProps
}

export const ServiceCard = ({
  sx = {},
  data,
  iconButtonProps,
  ...props
}: IServiceCardProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { name, description, feature_image } = data
  const {
    root,
    cardMedia,
    cardContentWrapper,
    cardContent,
    cardTitle,
    cardDescription,
    arrowNextButton,
  } = theme.components?.[`ServiceCard`]?.styleOverrides || {}

  const arrowNextIcon = useMemo(
    () => getIcon(theme?.assets?.nextIcon) || <ArrowNextIcon />,
    [theme]
  )

  const isRtl = theme.isRtl

  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <CardMedia sx={cardMedia} image={feature_image} />
      <Box sx={cardContentWrapper}>
        <CardContent sx={cardContent}>
          <Typography variant="subTitle" sx={cardTitle}>
            {t(name)}
          </Typography>
          <Typography variant="subTitle" sx={cardDescription}>
            {t(description)}
          </Typography>
        </CardContent>
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          className={isRtl ? "is-rtl" : ""}
          sx={arrowNextButton}
          {...iconButtonProps}
        >
          {arrowNextIcon}
        </IconButton>
      </Box>
    </Card>
  )
}
